import gql from 'graphql-tag'

export const getEventById = gql`
query getEventById($id: ID!, $userFilter: UserFilter) {
  Event(id: $id) {
    id
    createdAt
    name
    initiator {
      id
      name
    }
    participants(orderBy: updatedAt_DESC) {
      id
      name
      items {
        id
        name
        quantity
        unit
        type
      }
      attendedEvents {
        id
      }
    }
    items(filter: {
      user: $userFilter
    }) {
      id
      name
      quantity
      unit
      type
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/shared/queries.js